import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  'fw_wingstop-customized-reports-7375b6fb': {
    '/:brand/upsell': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'fw_wingstop/upsell',
        height: '100vh',
      },
    },
  },
}

export default demo
